import { render } from "./cooperation.vue?vue&type=template&id=c17b54d2&scoped=true"
import script from "./cooperation.vue?vue&type=script&lang=js"
export * from "./cooperation.vue?vue&type=script&lang=js"

import "./cooperation.vue?vue&type=style&index=0&id=c17b54d2&scoped=true&lang=css"

import exportComponent from "D:\\WorkFile\\Project\\uniapp-bajitu-user\\web-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c17b54d2"]])

export default __exports__